import { Component, ViewChild } from '@angular/core';
import { EmployeeConfirmationService } from '../../../Model/EmployeeConfirmation/employee-confirmation.service';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { CommonService } from '../../../Model/Common/common.service';
import { DownloadSampleService } from '../../../Model/DownloadSample/download-sample.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { CommonModule } from '@angular/common';
import { RouterOutlet, RouterModule } from '@angular/router';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';

@Component({
  selector: 'app-employee-confirmation-policies',
  standalone: true,
  imports: [CommonModule,RouterOutlet,RouterModule,DataTablesModule,LoaderComponent],
  templateUrl: './employee-confirmation-policies.component.html',
  styleUrl: './employee-confirmation-policies.component.scss'
})
export class EmployeeConfirmationPoliciesComponent {
  isDisabled: boolean = false;
  EmployeeConfirmationData :  any[] = [];
  TableDatas = [];
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  dtoptions: DataTables.Settings = {};
  constructor(
    private employeeconfirmation: EmployeeConfirmationService,
    protected common: CommonService,
    private tooltip : TooltipService,
    private download : DownloadSampleService,
    private toast :  ToastService
  ) { 
    this.common.getPageRights();
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.ESS_ConfirmationRuleLoad();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  ESS_ConfirmationRuleLoad() {
    this.isDisabled = true;
    this.employeeconfirmation.ESS_ConfirmationRuleLoad({ SelectType: 1, ESS_ConfirmationRuleID: 0 }).subscribe({
      next: (response) => {
        this.TableDatas = Object.values(response.Table);
        this.TableDatas.forEach((element:any) => {
          element.WebESSApplicability = response.Table1.filter((e:any) => e.WebESSApplicabilityId == element.WebESSApplicabilityId)[0].ApplicabilityName
        });
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }
  
  exportToExcel() {
    this.isDisabled = true
    const data = {
      SelectType: 'EmployeeConfirmationPolicyMasterExcel',
      Year: ''
    }
    this.download.ESS_ExcelDump(data).subscribe(
      data => {
        this.EmployeeConfirmationData = data;
        if( this.EmployeeConfirmationData.length > 0){
          // this.download.exportToExcel(this.EmployeeConfirmationData, "EmployeeConfirmationPolicies_data");
          this.download.exportToExcelWithProgress(this.EmployeeConfirmationData, "EmployeeConfirmationPolicies_data");
          this.isDisabled = false
        }
        else{
          this.toast.show({ message: 'No Data Found!', type: toastTypeEnum.warning });
          this.isDisabled = false
        }     
      });
  }
}
